import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListTriageCollectionsResponse } from './list-triage-collections-response';
import { listTriageCollectionsResponseSchema } from './list-triage-collections-response';

export async function listTriageCollectionsApi(): Promise<
  IValidatedResponse<IListTriageCollectionsResponse>
> {
  return getRequest<IListTriageCollectionsResponse>({
    path: '/sys/collections/v1/triage/list',
    schema: listTriageCollectionsResponseSchema,
  });
}
